import { IconButton } from "@similarweb/ui-components";
import type { IIconsButtonProps } from "@similarweb/ui-components";
import { StyledCardButtonContent } from "app/pages/sales-intelligence/pages/home/components/styles";
import type { PropsWithChildren } from "react";

type Props = PropsWithChildren<Partial<IIconsButtonProps>>;

const NewAssetIconButton = ({ children, onClick, iconName = "add", ...buttonProps }: Props) => {
    return (
        <IconButton
            type="outlined"
            {...buttonProps}
            iconName={iconName}
            onClick={onClick}
        >
            <StyledCardButtonContent>{children}</StyledCardButtonContent>
        </IconButton>
    );
};

export default NewAssetIconButton;
